var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenLibrary(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_345353_13314)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.06 3.36H4.01774L3.10218 2.47778H14.0977V1.49111L2.11552 1.54444L1.33329 0.813333H12.9666V0.00666667L0.459961 0V13.2067L3.45107 16H15.06C15.3244 16 15.54 15.78 15.54 15.5111V3.84889C15.54 3.57778 15.3244 3.36 15.06 3.36ZM3.33107 14.54L1.45107 12.8556L1.50885 2.30889L3.38885 4.07778L3.33107 14.54ZM6.79552 4.34444H10.9955V9.83111L8.89552 8.46L6.79552 9.83111V4.34444ZM4.31996 15.0133V4.34444H5.80441V11.6644L8.89552 9.64444L11.9866 11.6644V4.34444H14.5822V15.0133H4.31996Z",
    fill: "#396D87"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_345353_13314"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenLibrary);
export default __webpack_public_path__ + "static/media/GreenLibrary.ee11fab5158bd29e35472af7c806c96a.svg";
export { ForwardRef as ReactComponent };